import { apiAxios } from "./api-config/axiosConfig";

export const homeApis = {
  getInspectorReports: async (inspectorId: string) => {
    try {
      const token = localStorage.getItem("LVaccessToken");

      const response = await apiAxios.get(`/report/inspector/${inspectorId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error: any) {
      console.error("Inspector Report API Error:", error);
      throw error?.response?.data || error;
    }
  },

  submitReport: async (payload: {
    reportDetails: {
      address: string;
      lat: string;
      long: string;
      notes: string;
      illegalSmoking: string;
      zoningConcern: string;
      licenseConcern: string;
    };
    fileDetails: {
      filename: string;
      type: string;
      description: string;
    }[];
    files: File[];
  }) => {
    try {
      const token = localStorage.getItem("LVaccessToken");

      const formData = new FormData();
      formData.append("report_details", JSON.stringify([payload.reportDetails]));
      formData.append("report_file_detail", JSON.stringify(payload.fileDetails));
      payload.files.forEach((file) => {
        formData.append("file", file);
      });

      const response = await apiAxios.post(`/report/`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error: any) {
      console.error("Submit Report API Error:", error);
      throw error?.response?.data || error;
    }
  },
};
